import React from 'react';
import Dance from './Dance';
import {getDance, getVideoUrl} from "./AppUtils";
import { browserHistory } from 'react-router';

class DanceSingle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mounted: false
        };
    }

    componentDidMount() {

        getDance(this.props.params.danceId)
            .then((res) => {
                if (res.data.dances.length === 5) {
                    browserHistory.push('watch/completed');
                }
            });
    }

    render() {
        return (
            <div className="full">
                <div className="table">
                    <div className="table-cell">
                        <Dance danceId={this.props.params.danceId} play={true} browse={false} respond={true}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default DanceSingle;



// WEBPACK FOOTER //
// src/DanceSingle.js